import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataTask1200To1299Service {

  constructor() { }
}
